// Pixel portrait wrapper. Deterministic per agent name — same face everywhere.
import React, { useEffect, useRef } from "react";
import { agentPortrait } from "./portrait";

export function AgentPortrait({ agent, size = 40, className = "", testId }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    const node = agentPortrait(agent || { name: "unknown", department: "" }, size);
    ref.current.replaceChildren(node);
  }, [agent?.name, agent?.department, agent?.status, agent?.prop, size]);

  return (
    <span
      ref={ref}
      className={`inline-block rounded-md overflow-hidden align-middle ${className}`}
      style={{ width: size, height: size, background: "var(--panel-2)" }}
      data-testid={testId || `portrait-${agent?.name || "unknown"}`}
      aria-label={agent?.name || "agent"}
    />
  );
}
